/* TGFM: misura solo le CTA esplicite; gli eventi ecommerce restano a Shopify. */
(function () {
  'use strict';

  var script = document.currentScript;
  var measurementId = script && script.getAttribute('data-tgfm-ga4');
  if (!/^G-[A-Z0-9]+$/.test(measurementId || '') || window.__tgfmCtaTrackingInstalled) {
    return;
  }

  var allowedEvents = [
    'home_cta_click', 'home_category_click', 'home_guide_click', 'repair_page_click',
    'local_whatsapp_click', 'local_phone_click', 'local_directions_click',
    'repair_whatsapp_click', 'repair_phone_click', 'repair_directions_click',
    'product_option_contact_click',
    'engineering_cta_click', 'engineering_quote_submit'
  ];
  var viewsSent = false;
  var ownedGoogleTag = null;
  var ownedGoogleWindow = null;
  var ownedGoogleFrame = null;
  var googleReady = false;
  var googleFailed = false;
  var pendingConsentedClicks = [];

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(window['ga-disable-' + measurementId] !== true && privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.currentVisitorConsent === 'function' &&
        privacy.analyticsProcessingAllowed() === true && privacy.currentVisitorConsent().analytics === 'yes');
    } catch (_) {
      return false;
    }
  }

  function removeOwnedTag() {
    // La sola consent.update denied consente ancora ping senza cookie.
    // Opt-out e rimozione del frame interrompono anche Enhanced Measurement.
    pendingConsentedClicks = [];
    if (ownedGoogleWindow) ownedGoogleWindow['ga-disable-' + measurementId] = true;
    if (ownedGoogleFrame) ownedGoogleFrame.remove();
    ownedGoogleTag = null;
    ownedGoogleWindow = null;
    ownedGoogleFrame = null;
    googleReady = false;
    googleFailed = false;
  }

  function ensureGoogleTag() {
    if (!analyticsAllowed() || googleFailed) return false;
    if (ownedGoogleTag) return googleReady;
    // Riusa solo un consumatore relativo alla property, senza riconfigurarlo.
    var hasConsumer = Array.prototype.some.call(document.scripts || [], function (item) {
      try {
        var source = new URL(item.src || '', window.location.href);
        return source.origin === 'https://www.googletagmanager.com' &&
          source.pathname === '/gtag/js' && source.searchParams.get('id') === measurementId;
      } catch (_) { return false; }
    });
    hasConsumer = hasConsumer || Boolean(window.google_tag_manager && window.google_tag_manager[measurementId]);
    if (typeof window.gtag === 'function' && hasConsumer) return true;

    // Un tag nel documento principale attiverebbe gli automatismi della property
    // (click, scroll e history page_view), anche con send_page_view:false.
    // Il frame vuoto non contiene link, moduli o la history del negozio.
    // about:blank eredita origine e CSP Shopify; nessun dominio o proxy alternativo.
    var frame = document.createElement('iframe');
    // Layout non nullo: un frame display:none fa scattare lo scroll automatico
    // al 90% (altezza zero) della property. Rimane fuori schermo e inaccessibile.
    frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:1px;height:1px;border:0;visibility:hidden;pointer-events:none;';
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('title', 'Misurazione delle azioni TGFM');
    frame.setAttribute('data-tgfm-cta-frame', 'true');
    (document.body || document.documentElement).appendChild(frame);
    ownedGoogleFrame = frame;
    var tagWindow = frame.contentWindow;
    var tagDocument = frame.contentDocument;
    if (!tagWindow || !tagDocument || !tagDocument.head) {
      removeOwnedTag();
      googleFailed = true;
      return false;
    }
    ownedGoogleWindow = tagWindow;
    // Gli oggetti devono nascere nello stesso realm del tag Google: il suo
    // validatore scarta gli argomenti/oggetti creati nel documento genitore.
    tagDocument.open();
    tagDocument.write('<!doctype html><html><head><meta name="referrer" content="no-referrer"><title>TGFM</title>' +
      '<script>window.dataLayer=[];window.gtag=function(){window.dataLayer.push(arguments);};' +
      'window.tgfmCtaCommand=function(encoded,done){var args=JSON.parse(encoded);' +
      'if(args[0]==="js")args[1]=new Date();' +
      'if(args[0]==="event"&&typeof done==="function"){args[2].event_callback=function(){done();};args[2].event_timeout=180;}' +
      'window.gtag.apply(window,args);};</scr' + 'ipt></head>' +
      '<body style="margin:0;min-height:10000px"></body></html>');
    tagDocument.close();
    tagWindow.history.replaceState({}, '', safeUrl(window.location.href));
    if (typeof tagWindow.tgfmCtaCommand !== 'function') {
      removeOwnedTag();
      googleFailed = true;
      return false;
    }
    ownedGoogleTag = function () {
      tagWindow.tgfmCtaCommand(JSON.stringify(Array.prototype.slice.call(arguments)));
    };
    ownedGoogleTag('consent', 'default', {
      analytics_storage: 'denied', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    ownedGoogleTag('consent', 'update', {
      analytics_storage: 'granted', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    ownedGoogleTag('js', new Date());
    ownedGoogleTag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: safeUrl(window.location.href),
      page_referrer: safeUrl(document.referrer),
      page_title: 'TGFM'
    });

    var googleScript = tagDocument.createElement('script');
    googleScript.async = true;
    googleScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    googleScript.setAttribute('data-tgfm-cta-google-tag', 'true');
    googleScript.addEventListener('load', function () {
      if (ownedGoogleFrame !== frame || !analyticsAllowed()) return;
      googleReady = true;
      var clicks = pendingConsentedClicks;
      pendingConsentedClicks = [];
      if (analyticsAllowed()) clicks.forEach(sendClick);
    });
    googleScript.addEventListener('error', function () {
      if (ownedGoogleFrame !== frame) return;
      removeOwnedTag();
      googleFailed = true;
    });
    tagDocument.head.appendChild(googleScript);
    return false;
  }

  function consentChanged() {
    try {
      if (!analyticsAllowed()) {
        removeOwnedTag();
        return;
      }
      ensureGoogleTag();
      sendViews();
    } catch (_) {
      // CMP o script non disponibili: non bloccare la navigazione e non inviare.
      removeOwnedTag();
      googleFailed = true;
    }
  }

  function label(value) {
    return typeof value === 'string' && /^[a-z0-9_-]{1,100}$/i.test(value) ? value : '';
  }

  function safeUrl(value, allowPhone) {
    // Non inviare testo WhatsApp, query di ricerca, email, token o frammenti URL.
    if (!value) return '';
    try {
      var url = new URL(value, window.location.href);
      if (allowPhone && url.protocol === 'tel:') return 'tel:';
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
      return (url.origin + url.pathname).slice(0, 500);
    } catch (_) {
      return '';
    }
  }

  function sendClick(click) {
    if (!analyticsAllowed()) return;
    try {
      if (!ensureGoogleTag()) {
        if (!googleFailed && ownedGoogleTag && pendingConsentedClicks.length < 10) pendingConsentedClicks.push(click);
        return;
      }
      if (ownedGoogleTag && click.complete) {
        ownedGoogleWindow.tgfmCtaCommand(JSON.stringify(['event', click.name, click.parameters]), click.complete);
      } else {
        if (click.complete) {
          click.parameters.event_callback = click.complete;
          click.parameters.event_timeout = 180;
        }
        (ownedGoogleTag || window.gtag)('event', click.name, click.parameters);
      }
    } catch (_) {
      // Il tracking non deve mai impedire di aprire la pagina o contattare TGFM.
      if (ownedGoogleFrame) {
        removeOwnedTag();
        googleFailed = true;
      }
    }
  }

  function footerMetadata(element) {
    if (!element || typeof element.closest !== 'function' || !element.closest('footer, [role="contentinfo"]')) return null;
    try {
      var url = new URL(element.getAttribute('href') || '', window.location.href);
      if (url.username || url.password) return null;
      if (url.protocol === 'https:' && url.hostname === 'wa.me' && url.pathname === '/393488186021') {
        return { event: 'local_whatsapp_click', name: 'footer_whatsapp', area: 'store_footer' };
      }
      if (url.protocol === 'tel:' && url.pathname === '+393488186021' && !url.search && !url.hash) {
        return { event: 'local_phone_click', name: 'footer_phone', area: 'store_footer' };
      }
      if (url.protocol === 'https:' && url.hostname === 'maps.google.com' && url.pathname === '/maps' && url.searchParams.get('cid') === '4617851646001901740') {
        return { event: 'local_directions_click', name: 'footer_maps', area: 'store_footer' };
      }
    } catch (_) { /* Link non riconosciuto: nessun evento. */ }
    return null;
  }

  function internalNavigation(element, event) {
    // Un link interno puo' distruggere il frame prima che il tag scarichi il hit.
    // Il callback Google anticipa la partenza; 180 ms e' il limite assoluto.
    if (googleFailed || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        event.cancelable === false || typeof event.preventDefault !== 'function' ||
        element.tagName !== 'A' || element.hasAttribute('download')) return null;
    var target = element.getAttribute('target') || '';
    if (target && target !== '_self') return null;
    try {
      var url = new URL(element.getAttribute('href') || '', window.location.href);
      var current = new URL(window.location.href);
      if (url.origin !== current.origin || url.pathname + url.search === current.pathname + current.search) return null;
      var finished = false;
      var timer = window.setTimeout(done, 180);
      function done() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        window.location.assign(url.href);
      }
      event.preventDefault();
      return done;
    } catch (_) { return null; }
  }

  function sendViews() {
    // Eventi "a vista": elementi che compaiono solo dopo un'azione riuscita
    // (es. conferma del modulo preventivo). Una sola volta per pagina, solo con consenso.
    if (viewsSent || !analyticsAllowed()) return;
    var items = document.querySelectorAll('[data-track-view]');
    if (!items.length) return;
    viewsSent = true;
    Array.prototype.forEach.call(items, function (element) {
      var eventName = element.getAttribute('data-track-view');
      var name = label(element.getAttribute('data-track-name'));
      var area = label(element.getAttribute('data-track-area'));
      if (allowedEvents.indexOf(eventName) < 0 || !name || !area) return;
      sendClick({ name: eventName, complete: null, parameters: {
        send_to: measurementId,
        cta_name: name,
        cta_area: area,
        page_location: safeUrl(window.location.href),
        page_referrer: safeUrl(document.referrer),
        page_title: 'TGFM',
        transport_type: 'beacon'
      }});
    });
  }

  function onClick(event) {
    if (event.defaultPrevented || (typeof event.button === 'number' && event.button !== 0)) return;
    var target = event.target;
    var element = target && typeof target.closest === 'function' ? target.closest('[data-track]') : null;
    var footer = null;
    if (!element && target && typeof target.closest === 'function') {
      element = target.closest('a[href]');
      footer = footerMetadata(element);
      if (!footer) return;
    }
    if (!element || !document.documentElement.contains(element)) return;
    var eventName = footer ? footer.event : element.getAttribute('data-track');
    if (allowedEvents.indexOf(eventName) < 0 || !analyticsAllowed()) return;
    var name = footer ? footer.name : label(element.getAttribute('data-track-name'));
    var area = footer ? footer.area : label(element.getAttribute('data-track-area'));
    if (!name || !area) return;

    sendClick({ name: eventName, complete: internalNavigation(element, event), parameters: {
        send_to: measurementId,
        cta_name: name,
        cta_area: area,
        destination_url: safeUrl(element.getAttribute('href'), true),
        page_location: safeUrl(window.location.href),
        page_referrer: safeUrl(document.referrer),
        page_title: 'TGFM',
        transport_type: 'beacon'
    }});
  }

  function loadConsentApi() {
    // Senza questa richiesta Shopify espone solo un oggetto ridotto, privo di
    // analyticsProcessingAllowed/currentVisitorConsent: il consenso risulterebbe
    // sempre negato e nessun evento partirebbe (verificato in GA4 il 2026-10-13).
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.currentVisitorConsent === 'function') return;
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) consentChanged();
        });
      }
    } catch (_) { /* Nessuna API: nessun evento, la pagina funziona comunque. */ }
  }

  window.__tgfmCtaTrackingInstalled = true;
  // Delega per sezioni aggiunte dal theme editor e click da tastiera: un solo listener.
  // Il consenso viene riletto a ogni azione, senza memorizzare click prima del consenso.
  document.addEventListener('click', onClick);
  document.addEventListener('visitorConsentCollected', function () { loadConsentApi(); consentChanged(); });
  window.addEventListener('load', function () { loadConsentApi(); consentChanged(); }, { once: true });
  loadConsentApi();
  window.addEventListener('pageshow', consentChanged);
  consentChanged();
}());
